import * as core from '../../../../../../../core'

import { query } from './ideas-by-status.query'

export const RESOURCE = {
  payload: {
    alias: 'ideas.status.bar',
    description: 'Bar chart showing ideas by status',
    name: 'Ideas by Status',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
